//common utilities

const normalize = (value, min, max) => (value - min) / (max - min)

const lerp = (value, min, max) => (max - min) * value + min

export{normalize, lerp}